import React from 'react';
import './registrationplate.scss';

interface RegistrationPlateProps {
    reg: string;
}

const RegistrationPlate: React.FC<RegistrationPlateProps> = ({ reg }) => {
    const displayReg = (reg || '').trim().toUpperCase();
    return (<div className="registraion-plate"><div className="registraion-text">{displayReg}</div></div>);
};

export default RegistrationPlate;